import { useCallback, useEffect, useState } from "react";

import { ISegment, useSegmentFilterCascaded } from "../../helpers/segmentFilterHook";
import { BranchesDropdown, BrandsDropdown, ChannelsDropdown, MarketersDropdown, StatesDropdown } from "./";

export function SegmentFilters(props: Props) {
	const { onChange } = props;
	const [segmentFilters, setSegmentFilters] = useState<ISegment>(emptySegmentFilters);
	const availableSegments = useSegmentFilterCascaded(segmentFilters);

	const segmentChanged = useCallback(
		(value: any, name: string & keyof ISegment) => {
			setSegmentFilters({ ...segmentFilters, [name]: value });
		},
		[segmentFilters],
	);

	useEffect(() => {
		if (props.value) {
			setSegmentFilters(props.value);
		}
	}, [props.value]);

	useEffect(() => {
		if (JSON.stringify(segmentFilters) !== JSON.stringify(props.value)) {
			onChange(segmentFilters);
		}
	}, [segmentFilters]);

	//TODO: handle optional "All X" vs none selected just means all
	//TODO: handle auto-select if single for multi
	//Maybe if auto-selected (and only one option in master list), we just display nice text: "Brand: Spectrum"
	//TODO: setup cascading and active only etc
	return (
		<>
			<BrandsDropdown
				options={availableSegments.brands}
				loaded={availableSegments.brandsLoaded}
				value={segmentFilters.brandIds ?? []}
				changeHandler={segmentChanged}
			/>
			<ChannelsDropdown
				options={availableSegments.channels}
				loaded={availableSegments.channelsLoaded}
				value={segmentFilters.channelIds ?? []}
				changeHandler={segmentChanged}
			/>
			<MarketersDropdown
				options={availableSegments.marketers}
				loaded={availableSegments.marketersLoaded}
				value={segmentFilters.marketerIds ?? []}
				changeHandler={segmentChanged}
			/>
			<StatesDropdown
				options={availableSegments.states}
				loaded={availableSegments.statesLoaded}
				value={segmentFilters.stateIds ?? []}
				changeHandler={segmentChanged}
			/>
			<BranchesDropdown
				options={availableSegments.branches}
				loaded={availableSegments.branchesLoaded}
				value={segmentFilters.branchIds ?? []}
				changeHandler={segmentChanged}
			/>
		</>
	);
}

export const emptySegmentFilters: ISegment = {
	branchIds: [],
	brandIds: [],
	channelIds: [],
	marketerIds: [],
	stateIds: [],
};

interface Props {
	onChange: (filters: ISegment) => void;
	value?: ISegment;
}
